import Hero from "../components/MainPage/Hero"

function Home() {
  return (
    <>
      <Hero />
    </>
  )
}

export default Home
